import React from 'react';
import './ProductCard.css';

const ProductCard = ({ image, title }) => {
  return (
    <div className="product-card">
      <div className="product-image">
        <img src={image} alt={title} />
        <div className="product-overlay">
          <button className="quick-view">Quick View</button>
        </div>
      </div>
      <div className="product-info">
        <h4>{title}</h4>
      </div>
    </div>
  );
};

export default ProductCard;
